module.exports = __webpack_public_path__ + "img/add_on.5bce9a11.png";